/**
 * @generated SignedSource<<a261682802e6733850a921ce79c8da08>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "batchFinish"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "batchStart"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "timeZone"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tradeAggregation"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uuid"
},
v5 = [
  {
    "kind": "Variable",
    "name": "uuid",
    "variableName": "uuid"
  }
],
v6 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "aggregation",
      "variableName": "tradeAggregation"
    },
    {
      "kind": "Variable",
      "name": "finish",
      "variableName": "batchFinish"
    },
    {
      "kind": "Literal",
      "name": "groups",
      "value": [
        "SUMMARY_GROUP_TRADE_POINT",
        "SUMMARY_GROUP_TRADE_RULE",
        "SUMMARY_GROUP_DIRECTION",
        "SUMMARY_GROUP_TRADE_TYPE"
      ]
    },
    {
      "kind": "Variable",
      "name": "start",
      "variableName": "batchStart"
    },
    {
      "kind": "Variable",
      "name": "timeZone",
      "variableName": "timeZone"
    }
  ],
  "concreteType": "TradeSetSummary",
  "kind": "LinkedField",
  "name": "tradeSetSummary",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeSetSummaryKey",
      "kind": "LinkedField",
      "name": "key",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tradePointId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ruleId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "direction",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeSetSummaryValue",
      "kind": "LinkedField",
      "name": "data",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeRange",
          "kind": "LinkedField",
          "name": "range",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "start",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "finish",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "buyerTradePointIds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sellerTradePointIds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "directions",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "types",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "volume",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "averagePrice",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tradeCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "intervalCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": {
      "throwOnFieldError": true
    },
    "name": "dataBatchingPortfolioTradeSetSummaryQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Portfolio",
        "kind": "LinkedField",
        "name": "portfolio",
        "plural": false,
        "selections": [
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "dataBatchingPortfolioTradeSetSummaryQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Portfolio",
        "kind": "LinkedField",
        "name": "portfolio",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1bb6c492759c3bc41e8eb50dd6963461",
    "id": null,
    "metadata": {},
    "name": "dataBatchingPortfolioTradeSetSummaryQuery",
    "operationKind": "query",
    "text": "query dataBatchingPortfolioTradeSetSummaryQuery(\n  $uuid: ID!\n  $batchStart: Timestamp!\n  $batchFinish: Timestamp!\n  $timeZone: String!\n  $tradeAggregation: String!\n) {\n  portfolio(uuid: $uuid) {\n    tradeSetSummary(start: $batchStart, finish: $batchFinish, timeZone: $timeZone, aggregation: $tradeAggregation, groups: [SUMMARY_GROUP_TRADE_POINT, SUMMARY_GROUP_TRADE_RULE, SUMMARY_GROUP_DIRECTION, SUMMARY_GROUP_TRADE_TYPE]) {\n      key {\n        tradePointId\n        ruleId\n        direction\n        type\n      }\n      data {\n        range {\n          start\n          finish\n        }\n        buyerTradePointIds\n        sellerTradePointIds\n        directions\n        types\n        value\n        volume\n        averagePrice\n        tradeCount\n        intervalCount\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

node.hash = "4125b5dd16e9e1ae84b496a48e64db33";

export default node;
